import { useEffect, useState } from 'react';
import { WifiOff, RefreshCcw } from 'lucide-react';

export const ConnectionStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [pendingSync, setPendingSync] = useState(0);

  useEffect(() => {
    const handleOnline = () => {
       setIsOnline(true);
       // Mock syncing process
       setPendingSync(5);
       setTimeout(() => setPendingSync(0), 3000);
    };
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline && pendingSync === 0) return null;

  return (
    <div className={`fixed bottom-4 right-4 z-50 rounded-full px-4 py-2 flex items-center gap-2 text-sm font-bold shadow-lg animate-fade-in ${!isOnline ? 'bg-error text-on-error' : 'bg-warning text-warning-content'}`}>
      {!isOnline ? (
         <>
            <WifiOff size={16} /> Navegação Offline (Gravando na memória)
         </>
      ) : (
         <>
            <RefreshCcw size={16} className="animate-spin" /> Sincronizando {pendingSync} alterações...
         </>
      )}
    </div>
  );
};
